const semanticClassNames = {
  root: 'vector-image',
} as const;

export default semanticClassNames;
